import { render, staticRenderFns } from "./TheConfirm.vue?vue&type=template&id=6541acf4&scoped=true&"
import script from "./TheConfirm.vue?vue&type=script&lang=js&"
export * from "./TheConfirm.vue?vue&type=script&lang=js&"
import style0 from "./TheConfirm.vue?vue&type=style&index=0&id=6541acf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541acf4",
  null
  
)

export default component.exports